import { useCurrentProjectContext } from "@v2/contexts/CurrentProjectContext";
import useDefaultV2CustomDomain from "@v2/features/page-settings/useDefaultCustomDomain";

const usePublishedSiteUrls = ({
  pageRoutesToUseForPreview,
}: {
  pageRoutesToUseForPreview: string[];
}): string[] => {
  const { project } = useCurrentProjectContext();
  const defaultCustomDomain = useDefaultV2CustomDomain();

  // NOTE (Andrew, 2026-02-02): This hook is only used in Replo-hosted project contexts,
  // where shopDomainPrefix is always set during project creation. If this invariant
  // is violated, we return an empty array to fail gracefully.
  if (!project?.shopDomainPrefix) {
    return [];
  }

  const domain =
    defaultCustomDomain?.value ?? `${project.shopDomainPrefix}.reploshops.com`;

  const normalizeRoute = (route: string) => {
    const withLeadingSlash = route.startsWith("/") ? route : `/${route}`;
    return withLeadingSlash === "/" ? "" : withLeadingSlash;
  };

  return pageRoutesToUseForPreview.map(
    (pageRoute) => `https://${domain}${normalizeRoute(pageRoute)}`,
  );
};

export default usePublishedSiteUrls;
